import { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { fileUrl } from "./GraphicFilesPanel";

export function GraphicFileCard({ f, selected, onToggle, onChanged, usages }) {
  const [busy, setBusy] = useState(false);
  const [colors, setColors] = useState(f.colors || 6);

  const revector = async (mode) => {
    setBusy(true);
    try { await api.post(`/graphic-files/${f.id}/revectorize`, { colors, mode }); toast.success("Nouvelle version vectorielle"); onChanged(); }
    catch { toast.error("Erreur"); } finally { setBusy(false); }
  };
  const del = async () => {
    if (!window.confirm(`Supprimer « ${f.name} » ?`)) return;
    try { await api.delete(`/graphic-files/${f.id}`); onChanged(); } catch { toast.error("Erreur"); }
  };
  const setUsage = async (usage) => { try { await api.patch(`/graphic-files/${f.id}`, { usage }); onChanged(); } catch { toast.error("Erreur"); } };
  const link = "text-[11px] px-2 py-1 rounded bg-zinc-800 hover:bg-zinc-700 text-amber-300";

  return (
    <div className={`rounded-xl border p-3 bg-zinc-900 ${selected ? "border-amber-400" : "border-zinc-800"}`} data-testid={`gf-card-${f.id}`}>
      <div className="flex items-start gap-3">
        <input type="checkbox" checked={selected} onChange={onToggle} className="mt-1" data-testid={`gf-select-${f.id}`} />
        <div className="grid grid-cols-2 gap-2 flex-1">
          <figure className="bg-white rounded p-1"><img src={fileUrl(f.original_url)} alt="" className="h-24 w-full object-contain" /><figcaption className="text-[10px] text-zinc-600 text-center">Original</figcaption></figure>
          <figure className="bg-white rounded p-1"><img src={fileUrl(f.svg_url)} alt="" className="h-24 w-full object-contain" data-testid={`gf-svg-${f.id}`} /><figcaption className="text-[10px] text-zinc-600 text-center">Vectoriel v{f.version} · {f.svg_paths} tracés</figcaption></figure>
        </div>
      </div>
      <div className="mt-2 flex items-center justify-between gap-2">
        <div className="font-semibold text-sm text-zinc-100 truncate" title={f.name}>{f.name}</div>
        <select value={f.usage} onChange={(e) => setUsage(e.target.value)} className="bg-zinc-950 border border-zinc-700 rounded text-xs px-1 py-0.5" data-testid={`gf-usage-${f.id}`}>
          {usages.map((u) => <option key={u} value={u}>{u}</option>)}
        </select>
      </div>
      {f.notes && <p className="text-[11px] text-zinc-400 mt-1">{f.notes}</p>}
      <div className="flex flex-wrap gap-1.5 mt-2">
        <a href={fileUrl(f.svg_url)} download target="_blank" rel="noreferrer" className={link} data-testid={`gf-dl-svg-${f.id}`}>⬇ SVG</a>
        <a href={fileUrl(f.pdf_url)} download target="_blank" rel="noreferrer" className={link} data-testid={`gf-dl-pdf-${f.id}`}>⬇ PDF</a>
        <a href={fileUrl(f.png_hd_url)} download target="_blank" rel="noreferrer" className={link} data-testid={`gf-dl-png-${f.id}`}>⬇ PNG HD</a>
        <span className="ml-auto flex items-center gap-1 text-[11px] text-zinc-400">
          <input type="number" min="2" max="8" value={colors} onChange={(e) => setColors(Number(e.target.value))} className="w-10 bg-zinc-950 border border-zinc-700 rounded px-1" data-testid={`gf-colors-${f.id}`} />
          <button onClick={() => revector("color")} disabled={busy} className="px-1.5 py-0.5 rounded bg-zinc-800 hover:bg-zinc-700" data-testid={`gf-revector-${f.id}`}>↻ couleur</button>
          <button onClick={() => revector("binary")} disabled={busy} className="px-1.5 py-0.5 rounded bg-zinc-800 hover:bg-zinc-700" data-testid={`gf-revector-bw-${f.id}`}>↻ N&B</button>
          <button onClick={del} className="px-1.5 py-0.5 rounded text-rose-400 hover:bg-rose-500/10" data-testid={`gf-delete-${f.id}`}>✕</button>
        </span>
      </div>
    </div>
  );
}
